module.exports = __webpack_public_path__ + "img/tender-nkfi-02.e623ece3.webp";